// Assinatura de quem escreve.

import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import * as conta from "../api/conta";
import { explicar } from "../api/problema";
import { Secao } from "./DoisFatores";
import { useNaoSalvo } from "./naoSalvo";

export function Assinatura() {
  const fila = useQueryClient();
  const [texto, setTexto] = useState("");
  const [tocado, setTocado] = useState(false);
  const [erro, setErro] = useState("");
  const [pronto, setPronto] = useState(false);

  const atual = useQuery({ queryKey: ["conta", "assinatura"], queryFn: () => conta.assinatura() });

  // Só preenche enquanto a pessoa não mexeu: sem essa guarda, uma revalidação
  // do react-query jogaria fora o que ela está digitando.
  useEffect(() => {
    if (!tocado && atual.data) setTexto(atual.data.texto ?? "");
  }, [atual.data, tocado]);

  const salvar = useMutation({
    mutationFn: () => conta.salvarAssinatura(texto),
    onSuccess: (d) => {
      setErro("");
      setPronto(true);
      // Ver Filtros.tsx: sem atualizar o cache, o efeito reaplica o valor
      // antigo assim que "tocado" volta a ser falso.
      fila.setQueryData(["conta", "assinatura"], d ?? { texto });
      setTocado(false);
    },
    onError: (e) => {
      setPronto(false);
      setErro(explicar(e));
    },
  });

  // Comparação de VALOR, não `tocado`: quem digita e desfaz não tem nada a
  // salvar, e um aviso que não some se aprende a ignorar.
  const naoSalvo = useNaoSalvo("Assinatura", texto !== (atual.data?.texto ?? ""));

  return (
    <Secao titulo="Assinatura" icone="Pencil" naoSalvo={naoSalvo}>
      <p className="text-sm text-tinta-media">
        Acrescentada quando você escreve. Não vale para mensagem enviada por
        outro programa — o Thunderbird tem a assinatura dele.
      </p>
      <label htmlFor="assinatura" className="sr-only">
        Assinatura
      </label>
      <textarea
        id="assinatura"
        value={texto}
        onChange={(e) => {
          setTexto(e.target.value);
          setTocado(true);
          setPronto(false);
        }}
        rows={5}
        maxLength={4000}
        placeholder={"—\nSeu nome\nCargo · Empresa"}
        className="mt-3 w-full rounded-lg border border-linha px-3 py-2 text-sm leading-relaxed"
      />
      <div className="mt-2 flex items-center gap-3">
        <button
          onClick={() => salvar.mutate()}
          disabled={salvar.isPending}
          className="rounded-lg bg-acao px-4 py-2 text-sm text-white disabled:opacity-60"
        >
          {salvar.isPending ? "…" : "Salvar"}
        </button>
        {pronto && <span className="text-sm text-acao">Salva.</span>}
        <span className="ml-auto text-xs text-tinta-fraca tabular-nums">
          {texto.length}/4000
        </span>
      </div>
      {erro && <p className="mt-3 text-sm text-perigo">{erro}</p>}
    </Secao>
  );
}
